module.exports = __webpack_public_path__ + "img/能源集成监控.ed85068a.png";